import React, { useCallback, useRef, useState } from "react";

export type UseHoverResult = {
  ref: React.RefCallback<HTMLElement>;
  hovering: boolean;
};

const useHover = (): UseHoverResult => {
  const [hovering, setHovering] = useState<boolean>(false);
  const prevRef = useRef<HTMLElement>(null);

  const onMouseEnter = useCallback(() => setHovering(true), []);
  const onMouseLeave = useCallback(() => setHovering(false), []);

  const nodeRefCallback = useCallback<UseHoverResult["ref"]>(
    (node) => {
      if (prevRef.current) {
        prevRef.current.removeEventListener("mouseenter", onMouseEnter);
        prevRef.current.removeEventListener("mouseleave", onMouseLeave);
      }

      if (node?.nodeType === Node.ELEMENT_NODE) {
        node.addEventListener("mouseenter", onMouseEnter);
        node.addEventListener("mouseleave", onMouseLeave);
      }

      prevRef.current = node;
    },
    [onMouseEnter, onMouseLeave]
  );

  return {
    ref: nodeRefCallback,
    hovering
  };
};

export default useHover;
